var map = {
	"./defense.jpg": 3730,
	"./economy.jpg": 8446,
	"./education.jpg": 2356,
	"./environment.jpg": 5257,
	"./foreign.jpg": 354,
	"./healthcare.jpg": 5981,
	"./hero.jpg": 4480,
	"./immigration.jpg": 6076,
	"./infrastructure.jpg": 3829,
	"./justice.jpg": 577,
	"./social.jpg": 5697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7535;